import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import Printer from 'src/components/Printer';
import NoPrintersImage from 'src/assets/images/generic-printer.svg';
import {
  NoPrintersIcon,
  NoPrintersSection,
  PrinterAccount,
  PrinterBox,
  PrintersContainer
} from './styles';
import RemovePrinter from 'src/components/RemovePrinter';
import {
  removePrinterModalTypes,
  statusDeleteDeviceErrorMessage
} from 'src/components/RemovePrinter/constants';
import { useI18n } from '@jarvis/react-portal-addons';

const PrintersCollection = ({
  printersInfo,
  accountSolutions,
  refreshData
}) => {
  const { t } = useI18n();

  const [selectedDeviceData, setSelectedDeviceData] = useState(undefined);
  const [openRemoveDeviceModal, setOpenRemoveDeviceModal] = useState(false);
  const [removePrinterModalType, setRemovePrinterModalType] = useState(
    removePrinterModalTypes.PRINTER_MODAL_OPEN
  );
  const [removePrinterModalSubType, setRemovePrinterModalSubType] = useState(
    statusDeleteDeviceErrorMessage.NOT_MAPPED
  );

  const handleOpenRemoveDeviceModal = useCallback(
    (
      device,
      category,
      subCategory = statusDeleteDeviceErrorMessage.NOT_MAPPED
    ) => {
      setSelectedDeviceData(device);
      setOpenRemoveDeviceModal(true);
      setRemovePrinterModalType(category);
      setRemovePrinterModalSubType(subCategory);
    },
    []
  );
  const handleCloseModals = useCallback(() => {
    setOpenRemoveDeviceModal(false);
    setSelectedDeviceData(undefined);
  }, []);

  if (printersInfo.data?.length > 0) {
    return (
      <>
        <PrintersContainer>
          {printersInfo.data.map((printer) => (
            <PrinterBox
              key={printer.deviceId}
              appearance="dropShadow"
              content={
                <Printer
                  device={printer}
                  handleOpenRemoveDeviceModal={handleOpenRemoveDeviceModal}
                  accountSolutions={accountSolutions.data}
                />
              }
            />
          ))}
        </PrintersContainer>
        <RemovePrinter
          openModal={openRemoveDeviceModal}
          handleCloseModal={handleCloseModals}
          device={selectedDeviceData}
          refreshData={refreshData}
          handleOpenRemoveDeviceModal={handleOpenRemoveDeviceModal}
          removePrinterModalType={removePrinterModalType}
          removePrinterModalSubType={removePrinterModalSubType}
        />
      </>
    );
  }

  if (printersInfo.isFetching) {
    return null;
  }

  return (
    <PrintersContainer data-testid="consumer-printers-printersCard-empty">
      <PrinterBox
        appearance="dropShadow"
        content={
          <NoPrintersSection>
            <NoPrintersIcon
              src={NoPrintersImage}
              alt={t('myPrinters.noPrintersInList.message')}
            />
            <PrinterAccount
              className="body"
              data-testid="consumer-printers-printersCard-noPrintersText"
            >
              {t('myPrinters.noPrintersInList.message')}
            </PrinterAccount>
          </NoPrintersSection>
        }
      />
    </PrintersContainer>
  );
};

PrintersCollection.propTypes = {
  printersInfo: PropTypes.shape({
    data: PropTypes.arrayOf(
      PropTypes.shape({
        deviceId: PropTypes.string.isRequired
      })
    ),
    isFetching: PropTypes.bool.isRequired
  }).isRequired,
  accountSolutions: PropTypes.shape({
    data: PropTypes.object.isRequired
  }).isRequired,
  refreshData: PropTypes.func.isRequired
};

export default PrintersCollection;
